import * as React from "react";
import * as S from "@styled";
import { ProcessSidePanelType } from "../model/State";
import styled from "styled-components";
import theme from "styled-theming";
import { ThemeType } from "shared/styles/theme";

const controlsContainerBorderBottomColor = theme("mode", {
    [ThemeType.light]: S.Colors.purpleDark,
    [ThemeType.dark]: S.Colors.grey_4
});

const styledFlaskSelected = theme("mode", {
    [ThemeType.light]: S.Colors.white,
    [ThemeType.dark]: S.Colors.dark
})

const styledFlask = theme("mode", {
    [ThemeType.light]: S.Colors.purpleDark,
    [ThemeType.dark]: S.Colors.grey_4
})

const StyledSidePanelControls = styled.div`
    position: fixed;
    display: flex;
    top: 84px;
    right: 0px;
    gap: 2px;
    border-bottom: 2px solid ${controlsContainerBorderBottomColor};
    padding-right: 5px;
    z-index: 10;
`

const StyledFlask = styled.svg<{ $isSelected?: boolean }>`
    path {
        stroke: ${props => props.$isSelected ? styledFlaskSelected : styledFlask};
        fill: ${props => props.$isSelected ? styledFlaskSelected : styledFlask};
    }
`

const sharedIconStyles: React.CSSProperties = {
    fontSize: "26px"
}

export const SidePanelControls: React.FC<IRightSideBarProps> = (props) => {

    return (
        <StyledSidePanelControls>
            <S.TabButton
                id="select-settings-panel"
                title="Settings"
                variant={props.activePaneltype === ProcessSidePanelType.SettingsPanel ? S.TabButtonType.selected : S.TabButtonType.normal}
                onClick={props.onSelectSettingsPanel}
            >
                <i className="ci-settings" style={sharedIconStyles} title={FRENDS.Localizations.Settings} />
            </S.TabButton>
            <S.TabButton
                id="select-variables-panel"
                title="Variables"
                variant={props.activePaneltype === ProcessSidePanelType.VariablesPanel ? S.TabButtonType.selected : S.TabButtonType.normal}
                onClick={props.onSelectVariablesPanel}
            >
                <i className="ci-info_square_outline" style={sharedIconStyles} title={"Variables"} />
            </S.TabButton>
            <S.TabButton
                id="select-test-panel"
                title={FRENDS.Localizations.Test}
                variant={props.activePaneltype === ProcessSidePanelType.TestPanel ? S.TabButtonType.selected : S.TabButtonType.normal}
                onClick={props.onSelectTestPanel}
            >
                <StyledFlask $isSelected={props.activePaneltype === ProcessSidePanelType.TestPanel} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 22L20 22C20.553 22 21 21.553 21 21L21 18.41C21 17.887 20.787 17.373 20.417 17.003L15 11.586L15 4C15 3.653 14.82 3.332 14.525 3.149C14.365 3.05 14.183 3 14 3C13.847 3 13.5 3 13.5 3C13.5 3 10.5 3 10 3C9.29132 3 9 3.665 9 4.044L9 11.586L3.583 17.003C3.213 17.373 3 17.887 3 18.41L3 21C3 21.553 3.447 22 4 22ZM10.707 12.707C10.895 12.52 11 12.266 11 12L11 5L13 5L13 12C13 12.266 13.105 12.52 13.293 12.707L19 18.41L19 20L4.999 20L4.997 18.417L10.707 12.707Z" fill="#00ff00" />
                    <path d="M17.5 17L7 17L4 18.8182L4 21L20 21L20 18.8182L17.5 17Z" />
                </StyledFlask>
            </S.TabButton>
            <S.TabButton
                title={FRENDS.Localizations.Snippet}
                id="select-snippets"
                variant={props.activePaneltype === ProcessSidePanelType.SnippetsPanel ? S.TabButtonType.selected : S.TabButtonType.normal}
                onClick={props.onClickSnippetsButton}
            >
                <i className="ci-code" style={sharedIconStyles} title={FRENDS.Localizations.Snippets} />
            </S.TabButton>
        </StyledSidePanelControls>
    );

}

interface IRightSideBarProps {
    onSelectTestPanel: () => void;
    onSelectVariablesPanel: () => void;
    onSelectSettingsPanel: () => void;
    onClickMinimapButton: () => void;
    onClickSnippetsButton: () => void;
    activePaneltype: ProcessSidePanelType | undefined | boolean;
}
